import { CSO_CODE_CHALLENGE_KEY, CSO_STATE_KEY } from '@constants/constants';

import { removeStorageItems } from './utils';

/**
 * Remove CSO login params on local storage
 * @returns void
 */
export const removeCsoLoginParamsOnLocalStorage = () =>
  removeStorageItems([CSO_CODE_CHALLENGE_KEY, CSO_STATE_KEY]);
